<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    import { onMount, onDestroy, afterUpdate } from 'svelte';
    import Flatpickr from 'svelte-flatpickr';

    import type flatpickr from 'flatpickr';

    export let open = false;
    export let options: Record<string, unknown> = {};
    export let dateSelected: Date | undefined;
    export let nextMonthArrowId: string;
    export let prevMonthArrowId: string;
    export let handleChange: (value: CustomEvent) => void;

    let fp: flatpickr.Instance | undefined;
    let calendarVisible = false;

    afterUpdate(() => {
        if (open) {
            calendarVisible = open;
        } else {
            setTimeout(() => {
                calendarVisible = open;
            }, 500);
        }
    });

    let nextMonthKeydownHandler: (event: KeyboardEvent) => void;
    let nextMonthClickHandler: (event: MouseEvent) => void;
    let prevMonthKeydownHandler: (event: KeyboardEvent) => void;
    let prevMonthClickHandler: (event: MouseEvent) => void;

    onMount(() => {
        const nextMonthArrow = document.getElementById(nextMonthArrowId);
        const prevMonthArrow = document.getElementById(prevMonthArrowId);

        nextMonthKeydownHandler = (event: KeyboardEvent) => {
            handleMonthChange(event, 1);
        };
        prevMonthKeydownHandler = (event: KeyboardEvent) => {
            handleMonthChange(event, -1);
        };
        // Fixing lack of :focus-visible support in Safar / focus persisting after click
        nextMonthClickHandler = (event: MouseEvent) => {
            (event.target as HTMLElement).blur();
        };
        prevMonthClickHandler = (event: MouseEvent) => {
            (event.target as HTMLElement).blur();
        };

        nextMonthArrow?.addEventListener('keydown', nextMonthKeydownHandler);
        nextMonthArrow?.addEventListener('click', nextMonthClickHandler);
        prevMonthArrow?.addEventListener('keydown', prevMonthKeydownHandler);
        prevMonthArrow?.addEventListener('click', prevMonthClickHandler);
    });

    onDestroy(() => {
        const nextMonthArrow = document.getElementById(nextMonthArrowId);
        const prevMonthArrow = document.getElementById(prevMonthArrowId);

        if (nextMonthArrow) {
            nextMonthArrow.removeEventListener('keydown', nextMonthKeydownHandler);
            nextMonthArrow.removeEventListener('click', nextMonthClickHandler);
        }

        if (prevMonthArrow) {
            prevMonthArrow.removeEventListener('keydown', prevMonthKeydownHandler);
            prevMonthArrow.removeEventListener('click', prevMonthClickHandler);
        }
    });

    const handleMonthChange = (event: KeyboardEvent, direction: number) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            fp?.changeMonth(direction);
        }
    };

    const borderRadius = getBorderRadius('datePickerDay');

    let calendarWrapper: HTMLDivElement | undefined;

    const handleReady = (
        event: CustomEvent<[unknown, unknown, { days: { children: HTMLCollection } }]>,
    ) => {
        setTimeout(() => {
            if (!calendarWrapper) {
                return;
            }

            const elements = event.detail[2].days.children;

            Array.from(elements).forEach((el: Element) => el.classList.add(borderRadius));
        });
    };
</script>

<div
    class="fun-pointer-events-auto fun-z-[10] fun-w-full fun-p-4"
    on:click|stopPropagation
    on:keydown|stopPropagation
    bind:this={calendarWrapper}
    role="button"
    tabindex="0"
>
    {#if calendarVisible}
        <Flatpickr
            name="date"
            {options}
            bind:value={dateSelected}
            on:ready={handleReady}
            on:change={handleChange}
            bind:flatpickr={fp}
        />
    {:else}
        <div
            class="fun-pointer-events-none fun-flex fun-h-[297px] fun-w-full fun-min-w-[329px] fun-flex-col fun-p-4"
        >
            <div class="fun-h-8 fun-animate-pulse-shadow fun-rounded fun-bg-gray-100" />
            <div
                class="fun-mb-3 fun-mt-4 fun-h-7 fun-animate-pulse-shadow fun-rounded fun-bg-gray-100"
            />
            <div class="fun-h-[221px] fun-animate-pulse-shadow fun-rounded fun-bg-gray-100" />
        </div>
    {/if}
</div>
